import { Transaction } from 'store/deliveryLog';

export const formatCardDetails = (t: Transaction): string => {
  const cardNumber = t.cardBin || t.cardLastFour ? `${t.cardBin ?? ''}*****${t.cardLastFour ?? ''}` : undefined;
  return [t.cardholderName, t.cardType, cardNumber, t.cardExpiry && `Exp ${t.cardExpiry}`].filter(Boolean).join(' · ');
};
